import type {
  ApiIntegrationWithViewConfig,
  ApiMirrorRegistry,
} from '@fabric-app/types/connections';
import { useMutationIntegrationDelete } from '@fabric-app/business/connections/mutations/useMutationIntegrationDelete';
import { useMutationMirrorRegistryDelete } from '@fabric-app/business/connections/mutations/useMutationMirrorRegistryDelete';
import { useCallback } from 'react';

export const useRemoveMirrorRegistry = () => {
  const mutationDeleteIntegration = useMutationIntegrationDelete();
  const mutationMirrorRegistryDelete = useMutationMirrorRegistryDelete();

  const removeConnection = useCallback(
    async (variables: {
      integration: ApiIntegrationWithViewConfig;
      mirrorRegistry: ApiMirrorRegistry;
    }) => {
      const { integration, mirrorRegistry } = variables;
      if (integration.viewConfig.isSingleMirror) {
        await mutationDeleteIntegration.mutateAsync({ integration });
      } else {
        await mutationMirrorRegistryDelete.mutateAsync({ mirrorRegistry });
      }
    },
    [mutationMirrorRegistryDelete, mutationDeleteIntegration],
  );

  return removeConnection;
};
